import React from "react";
import { motion, useReducedMotion } from "framer-motion";

/**
 * Scroll-reveal wrapper. Fades and translates children into view on scroll.
 *
 * Props:
 *   delay: seconds (default 0)
 *   direction: "up" | "down" | "left" | "right" | "none" (default "up")
 *   distance: px (default 24)
 *   duration: seconds (default 0.6)
 *   once: only trigger once (default true)
 *   as: element tag (default "div")
 */
export const FadeIn = ({
  children,
  delay = 0,
  direction = "up",
  distance = 24,
  duration = 0.6,
  once = true,
  as = "div",
  className,
  ...props
}) => {
  const shouldReduce = useReducedMotion();
  const MotionTag = motion[as] || motion.div;

  const axisMap = {
    up: { y: distance },
    down: { y: -distance },
    left: { x: distance },
    right: { x: -distance },
    none: {},
  };

  const hidden = shouldReduce
    ? { opacity: 0 }
    : { opacity: 0, ...axisMap[direction] };
  const shown = shouldReduce
    ? { opacity: 1 }
    : { opacity: 1, x: 0, y: 0 };

  return (
    <MotionTag
      className={className}
      initial={hidden}
      whileInView={shown}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration, delay, ease: [0.22, 1, 0.36, 1] }}
      {...props}
    >
      {children}
    </MotionTag>
  );
};

export default FadeIn;
